import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Button } from 'react-bootstrap';


const AdminNavbar = () => {
    const history = useHistory();

    const handleLogout = () => {
        localStorage.setItem('isAdmin', 'false');
        localStorage.setItem('usuario', "");
        history.push('/');
    };

    return (
        <header className="admin-navbar">
            <div className="container mx-auto">
                <nav className="navbar-menu">
                    <ul>
                        <li className="pt-1"><Link to="/">  Home</Link></li>
                        <li>
                            <Button onClick={handleLogout} variant="primary">
                                Logout
                            </Button>
                        </li>
                    </ul>
                </nav>
            </div>
        </header>
    );
}

export default AdminNavbar;